const fixDataTypes = sheetAsJson =>
  sheetAsJson.map(currencyConversionRate => ({
    ...currencyConversionRate,
    openSpotRate: isNaN(currencyConversionRate.openSpotRate) || !currencyConversionRate.openSpotRate
      ? currencyConversionRate.openSpotRate
      : parseFloat(currencyConversionRate.openSpotRate),
    endSpotRate: isNaN(currencyConversionRate.endSpotRate) || !currencyConversionRate.endSpotRate
      ? currencyConversionRate.endSpotRate
      : parseFloat(currencyConversionRate.endSpotRate),
    monthlyOperatingRate: isNaN(currencyConversionRate.monthlyOperatingRate)
    || !currencyConversionRate.monthlyOperatingRate
      ? currencyConversionRate.monthlyOperatingRate
      : parseFloat(currencyConversionRate.monthlyOperatingRate),
    weightedAverageRate: isNaN(currencyConversionRate.weightedAverageRate)
    || !currencyConversionRate.weightedAverageRate
      ? currencyConversionRate.weightedAverageRate
      : parseFloat(currencyConversionRate.weightedAverageRate),
    fromCurrencyPrecision: isNaN(currencyConversionRate.fromCurrencyPrecision)
    || !currencyConversionRate.fromCurrencyPrecision
      ? currencyConversionRate.fromCurrencyPrecision
      : parseFloat(currencyConversionRate.fromCurrencyPrecision),
    toCurrencyPrecision: isNaN(currencyConversionRate.toCurrencyPrecision)
    || !currencyConversionRate.toCurrencyPrecision
      ? currencyConversionRate.toCurrencyPrecision
      : parseFloat(currencyConversionRate.toCurrencyPrecision),
  }));

export default fixDataTypes;
